import request from '@/utils/request'

export function epmsa060List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa060/epmsa060List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa060PrtSave(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa060/epmsa060PrtSave`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa060PrtDelete() {
  return request({
    url: `/outsoucingBlockControl/epmsa060/epmsa060PrtDelete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },  
  })
}


//epms9113Xls
export function epmsa060Xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa060/epmsa060Xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `T-Bar Status.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}